import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";
import { FiltroPolizaContableComponent } from "./filtro";


type Entity = models.PolizaContableDto;
const resource = resources.Contabilidad;
interface State {
    filtro: models.FiltroPolizaContable;
}

interface Props {
    permisos: models.Rol;
}

class PolizaContableListNoRX extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: {EsLogistica:false} };
    }

    filtro = (props: Props, state: State) => state.filtro;
    permisos = (props: Props, state: State) => props.permisos;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.ConsultarPolizas, filtro));

    onVer = async (x: Entity) => history.go("./" + x.IdRegistro);

    onReenviar = async (x: Entity) => {
        if (await kea.yesno("¿Reenviar poliza al sistema de contabilidad con IdSistema " + x.IdSistemaContabilidad + "?", "CUIDADO: Un reenvío puede ocasionar que la misma póliza se registre más de una vez en el sistema de contabilidad")) {
            const nuevoIdSistema = await resource.ReenviarPoliza(x.IdRegistro);
            await kea.message("La poliza se reenvió con éxito", "El nuevo IdSistema es " + nuevoIdSistema);
        }
    }

    render() {
        const items = this.items(this.props, this.state);
        const permisos = this.permisos(this.props, this.state);
        const cols = columnas(this, permisos);
        return (
            <div>
                <kea.Title titulo="Pólizas contables" onRegresar={() => history.go("../")} />

                <FiltroPolizaContableComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                <kea.Grid2 columnas={cols} cookieKey={"PolizaContableListCookieKey"} items={items} />
            </div>
        )
    }
}


const PolizaContableListRX = componentToRx(PolizaContableListNoRX);

export class PolizaContableList extends React.PureComponent {
    render() {
        return (
            <PolizaContableListRX permisos={resources.User.PermisoRx} />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/list/list.tsx